import React, { memo, useState } from 'react';
import luckImage from '@/assets/images/login/lock.png';
import closeImage from '@/assets/images/login/inp_close.png';
import { Form, Input, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import '../index.less';
import { registerSliderProps, apiGetChangeByPhone } from '../server';
import { validatereset } from '../validateLogin';
// import { aliyunSlideProps } from '@/components/Login/typings';
import Verify from '../slideVerifyNew';
import AccountExists from '../dialog';
import HeadBtn from '../components/headBtn';
import { lmessage } from '../message';

interface sign extends registerSliderProps {
  policy?: boolean;
}

function LoginReset() {
  const [form] = Form.useForm();
  const history: any = useHistory();
  const [canSign, setCanSign] = useState<boolean>(false);
  const [showVerify, setShowVerify] = useState<boolean>(false);
  const [dialogVisible, setDialogVisible] = useState<boolean>(false);
  const [dialogTitle] = useState<string>('');
  const [dialogContent] = useState<string | undefined>('');
  const [isComposition, setIsComposition] = useState<boolean>(false);
  const code: string = history.location?.state?.code;
  // const phone: string = history.location?.state?.phone;
  const account: string = history.location?.state?.account;
  function formSubmit() {
    form.validateFields().then(res => {
      const values = res as sign;
      const validate = validatereset(
        {
          password: values.password,
          newpassword: values.recoveryPwd
        },
        3
      );
      if (validate !== '') return lmessage.error(validate);
      // setShowVerify(true);
      slideChange();
    });
  }
  function changeStatus() {
    const formData: registerSliderProps = form.getFieldsValue();
    if (formData.password && formData.recoveryPwd) {
      setCanSign(true);
    } else {
      setCanSign(false);
    }
  }
  const handleComposition = (e: any) => {
    if (e.type === 'compositionend') {
      setIsComposition(false);
    } else {
      setIsComposition(true);
    }
  };
  const handlePercentMatchPwd = (e: any) => {
    if (isComposition === true) return;
    const value = e.target.value;
    form.setFieldsValue({
      password: value.replace(/[\W]/g, '')
    });
    changeStatus();
  };
  const handlePercentMatchRecoveryPwd = (e: any) => {
    if (isComposition === true) return;
    const value = e.target.value;
    form.setFieldsValue({
      recoveryPwd: value.replace(/[\W]/g, '')
    });
    changeStatus();
  };
  function backChange() {
    setShowVerify(false);
  }
  const slideChange = async () => {
    const formData: sign = form.getFieldsValue();
    const obj: any = {
      code: code,
      account: account,
      newpassword: formData.password,
      repassword: formData.recoveryPwd
    };
    let res: any = await apiGetChangeByPhone(obj);
    if (!res.code) res = res.data;
    if (res.code === 200) {
      lmessage.success('修改密码成功');
      return history.replace('/login/account');
    } else {
      lmessage.error(res.msg);
    }
    setShowVerify(false);
  };
  const footerBtnChange = (params: string) => {
    if (params === 'login') {
      return history.replace('/login/account');
    }
    return setDialogVisible(false);
  };
  return (
    <div className="main_position_box">
      <HeadBtn></HeadBtn>
      <div className="login-switch_mold">
        <div className="currnt_f">密码重置</div>
      </div>
      <div className="login-form_box" id="login_drop">
        <Form form={form} onFinish={formSubmit} autoComplete="off">
          <Form.Item name="password">
            <Input.Password
              placeholder="请设置密码，长度6-20个字符"
              maxLength={20}
              onCompositionStart={handleComposition}
              onCompositionEnd={handleComposition}
              onKeyUp={event => handlePercentMatchPwd(event)}
              iconRender={visible => {
                return (
                  <div>
                    {!visible ? (
                      <span className="password_icon password_hide_icon"></span>
                    ) : (
                      <span className="password_icon password_show_icon"></span>
                    )}
                  </div>
                );
              }}
              prefix={<img className="password_icon" src={luckImage} alt="" />}
              allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
            ></Input.Password>
          </Form.Item>
          <Form.Item name="recoveryPwd" style={{ marginBottom: '24px' }}>
            <Input.Password
              placeholder="两次输入的密码请保持一致"
              maxLength={20}
              onCompositionStart={handleComposition}
              onCompositionEnd={handleComposition}
              onKeyUp={event => handlePercentMatchRecoveryPwd(event)}
              iconRender={visible => {
                return (
                  <div>
                    {!visible ? (
                      <span className="password_icon password_hide_icon"></span>
                    ) : (
                      <span className="password_icon password_show_icon"></span>
                    )}
                  </div>
                );
              }}
              prefix={<img className="password_icon" src={luckImage} alt="" />}
              allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
            ></Input.Password>
          </Form.Item>
          {!showVerify ? null : <Verify backChange={backChange} slideChange={slideChange} registerStatus={3}></Verify>}
          <Button
            style={{ display: showVerify ? 'none' : 'block' }}
            className={canSign ? 'login-form_box__submit_button' : 'login-form_box__submit_button disabled'}
            htmlType="submit"
          >
            重置
          </Button>
        </Form>
      </div>
      <AccountExists
        visible={dialogVisible}
        visableTitle={dialogTitle}
        current={2}
        visableHint={dialogContent}
        footerBtnChange={footerBtnChange}
      ></AccountExists>
    </div>
  );
}
export default memo(LoginReset);
